module.exports = __webpack_public_path__ + "img/weightlifting_07-28-2021.6444e9cb.jpg";